import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_have_fire_detection_alarm_system_line'

export const dataPointDefinition = {
  retracedId: 'does_facility_have_fire_detection_alarm_system_line',
  name: 'Does the facility have a fire detection and alarm system in line with legal requirements?',
  description:
    'The purpose of a fire detection and alarm system is for early detection and reporting, so as to reduce the time needed to implement fire-fighting measures and to limit the impact of the fire.',
  meta: {
    slcpMeta: {
      key: 'hs-eme-1',
      number: 'HS-EME-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30590,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
